
import { MergeDatasetData, MergeFieldData, MergeGroup, MergeSchemaData, MergeSourceData } from './model'
import * as Enumerable from 'linq';
import { ActivityEntityName } from '../../../entities/shared/activity.entity.name';
import { getMergeSourceEntity } from './utilities';

export class MergeCatalog {

    private static readonly sources = new Map<ActivityEntityName, MergeSourceData[]>();
    private static readonly datasets = new Map<ActivityEntityName, MergeDatasetData>();
    private static readonly schemas = new Map<String, MergeSchemaData>();

    public static registerDataset(dataset: MergeDatasetData) {

        const existingSources = this.sources.get(dataset.entity);

        dataset.sources = Enumerable
            .from(dataset.sources)
            //.select(x => ({ ...x, entity: dataset?.entity }))
            .select(x => ({ ...x, entity: getMergeSourceEntity(x.schema) }))
            .toArray();

        const sources = Enumerable
            .from(existingSources)
            .concat(dataset.sources)
            .distinct(x => x.name)
            .toArray();

        this.datasets.set(dataset.entity, dataset);
        this.sources.set(dataset.entity, sources);

    }

    public static getDataset(entity: ActivityEntityName): MergeDatasetData {
        return this.datasets.get(entity);
    }

    public static getSources(entity: ActivityEntityName): MergeGroup[] {

        const mainDataset = this.datasets.get(entity);

        const dependsOn = Enumerable
            .from(mainDataset?.dependsOn)
            .select(item => this.datasets.get(item))
            .selectMany(x => x.sources)
            .toArray();

        const all = Enumerable
            .from(mainDataset?.sources ?? [])
            .concat(dependsOn)
            .select(x => {

                const schema = Array.isArray(x?.schema)
                    ? x?.schema[0] as MergeSchemaData
                    : x?.schema;

                const fields = Enumerable
                    .from(schema?.fields)
                    .select(f => {
                        return {
                            ...f,
                            name: [x?.name, f?.name]?.join('.'),
                            source: x?.displayName
                        } as MergeFieldData;
                    })
                    .toArray();

                return {
                    name: x?.name,
                    displayName: x?.displayName,
                    fields: fields,
                    entity: x?.entity
                } as MergeGroup
            })
            .toArray();

        all.push({
            name: 'Current User',
            displayName: 'Current User',
            fields: [],
            entity: ActivityEntityName.ContactEmployee
        })

        return all;

    }

    public static registerMergeSchema(schema: MergeSchemaData) {
        if (!schema.name) {
            return;
        }

        this.schemas.set(schema.name, schema);
    }

    public static getMergeSchema(schemaName: string): MergeSchemaData {
        return this.schemas.get(schemaName);
    }

    public static test() { }

}